import type { FlowId } from '@/flows/types';
import type { WorkflowUiPhase } from '@/components/workflow/types';

export type FlowSurfaceId =
  | 'thread'
  | 'form'
  | 'bulk-review'
  | 'approval'
  | 'success'
  | 'saving-exclusive';

export interface ResolveSurfaceInput {
  flowId: FlowId;
  uiPhase: WorkflowUiPhase;
  formStep: string;
  formSurface?: 'form' | 'bulk-review';
  exclusiveSavingScreen?: boolean;
  hasConfirmStep: boolean;
}

const LOADING_PHASES: WorkflowUiPhase[] = ['thinking', 'working', 'almost-ready', 'preview'];

export function resolveSurface(input: ResolveSurfaceInput): FlowSurfaceId {
  const { uiPhase, formStep, formSurface = 'form', exclusiveSavingScreen } = input;

  if (uiPhase === 'success') return 'success';

  if (uiPhase === 'saving' && exclusiveSavingScreen) return 'saving-exclusive';

  if (LOADING_PHASES.includes(uiPhase)) return 'thread';

  if (uiPhase === 'form') {
    if (formSurface === 'bulk-review') return 'bulk-review';
    if (formStep === 'confirm') return 'approval';
    return 'form';
  }

  if (uiPhase === 'saving') return 'thread';

  return 'thread';
}

export function isFormSurface(surface: FlowSurfaceId): boolean {
  return surface === 'form' || surface === 'approval';
}

export function isBulkReviewSurface(surface: FlowSurfaceId): boolean {
  return surface === 'bulk-review';
}
